import { useEffect, useState } from "react";
import {
  getService,
  PostServiceWithFile,
} from "../GenericServices/genericService";
import { resources_EN } from "../GenericServices/componentUtils";
import Swal from "sweetalert2";

const AddProductModal = ({ showAddModal, setShowAddModal, getProductAPI }) => {
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    quantity: "",
    category: "",
    image: null,
    description: "",
  });
  const [category, setCategory] = useState([]);

  useEffect(() => {
    getCategoryAPI();
  }, []);

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      image: e.target.files[0],
    });
  };

  const handleAdd = () => {
    const url = "myNewAPI/add_product.php";
    const data = {
      prod_name: formData.name,
      prod_price: formData.price,
      prod_quantity: formData.quantity,
      cat_id: formData.category,
      prod_image: formData.image,
      prod_description: formData.description,
    };
    PostServiceWithFile(url, data, modal);
  };

  const getCategoryAPI = () => {
    const url = "myNewAPI/get_category.php";
    getService(url, {}, setCategoryData);
  };

  const setCategoryData = (response) => {
    setCategory(response.category);
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        setShowAddModal(false);
        setFormData({
          name: "",
          price: "",
          quantity: "",
          category: "",
          image: null,
          description: "",
        });
        getProductAPI();
      }
    });
  };
  console.log("FormData", category);
  return (
    showAddModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center p-4">
        <div className="bg-white rounded-lg p-6 w-full max-w-md">
          <h2 className="text-xl font-bold mb-4">Add Product</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleAdd();
            }}
          >
            <input
              type="text"
              placeholder="Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <input
              type="number"
              placeholder="Price"
              value={formData.price}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  price: parseFloat(e.target.value),
                })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <input
              type="number"
              placeholder="Quantity"
              value={formData.quantity}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  quantity: parseInt(e.target.value),
                })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <select
              placeholder="Category"
              value={formData.category}
              onChange={(e) => {
                console.log("Event:", e.target.value);
                setFormData({ ...formData, category: e.target.value });
              }}
              className="w-full mb-4 p-2 border"
              required
            >
              <option value="">Select Category</option>
              {category.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {" "}
                  {cat.cat_title}{" "}
                </option>
              ))}
            </select>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Product Image
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="w-full p-2 border"
                required={!formData.image}
              />
              {formData.image && (
                <img
                  src={URL.createObjectURL(formData.image)}
                  alt="Preview"
                  className="mt-2 w-24 h-24 object-cover"
                />
              )}
            </div>
            <textarea
              placeholder="Description"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => setShowAddModal(false)}
                className="mr-4 px-4 py-2 text-gray-600"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white"
              >
                Add
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
};

export default AddProductModal;
